

















































// Importing components
import BaseModalProduct from '@/ui/BaseModalProduct.vue';
// Importing functions
import {getProducts} from '@/ts/products/get-products';
// Importing an event bus
import {EventBus} from '@/ts/event-bus';

export default {
    name: 'ThePreviewProducts',
    components: {
        BaseModalProduct,
    },
    props: {
        search: String,
    },
    data() {
        return {
            products: Array(),
            categories: Array(),
        };
    },
    mounted() {
        getProducts(this.$route.query.restaurant).then((response: any) => {
            if (response.hasOwnProperty('products')) {
                this.products = response.products;
            }
            if (response.hasOwnProperty('menu-categories')) {
                this.categories = response['menu-categories'].sort((a, b) => {
                    return (a.attributes.order > b.attributes.order) ? 1 :
                        ((b.attributes.order > a.attributes.order) ? -1 : 0);
                });

            }
        });
    },
    methods: {
        show(id) {
            this.$modal.show('modal_' + id);
        },
        checkProduct(products, category) {
            return products.find((product) => Number(product.attributes.menu_category_id) === Number(category.id));
        },
        getMin(array) {
            return Math.min.apply(null, array.map((item) => {
                return item.attributes.price_with_vat;
            })).toFixed(2);
        },
        newItem(data) {
            EventBus.$emit('newItem', data);
        },
    },
    watch: {
        search(value) {
            this.$store.dispatch('setQueryParam', this.search);
            getProducts(this.$route.query.restaurant).then((response: any) => {
                if (response.hasOwnProperty('products')) {
                    this.products = response.products;
                }
            });
        },
    },
};
